import _ from "lodash";
import {
	GitHub,
	Instagram,
	Linkedin,
	Mail,
	Phone,
	Twitter,
} from "react-feather";

export const max = (a, b) => (a > b ? a : b);
export const min = (a, b) => (a < b ? a : b);

export const sleep = (seconds) =>
	new Promise((resolve) => setTimeout(resolve, seconds * 1000));

export const randomize = (low, high) =>
	Math.floor(Math.random() * +high + +low);

export const omit = (obj, key) => {
	const { [key]: omitted, ...rest } = obj;
	return rest;
};

export const getIcon = (a) => {
	switch (_.lowerCase(a)) {
		case "github":
			return <GitHub />;
		case "linkedin":
			return <Linkedin />;
		case "mail":
			return <Mail />;
		case "twitter":
			return <Twitter />;
		case "phone":
			return <Phone />;
		case "instagram":
			return <Instagram />;
		default:
			break;
	}
};

export const getLink = (service, username) => {
	if (_.lowerCase(service) !== "phone" && username.slice(0, 4) === "http")
		return username;
	switch (_.lowerCase(service)) {
		case "github":
			return `https://github.com/${username}`;
		case "linkedin":
			return `https://linkedin.com/in/${username}`;
		case "mail":
			return `mailto:${username}`;
		case "twitter":
			return `https://twitter.com/${username}`;
		case "phone":
			return `tel:${username}`;
		case "instagram":
			return `https://instagram.com/${username}`;
		default:
			break;
	}
};

export const getCardFromPerson = (person) => ({
	name: person?.name,
	image: person?.image,
	title: person?.title,
	status: person?.status,
	email: person?.mail,
	roll: person?.roll,
	verified: person?.verified,
	tags: person?.tags.split(","),
	socials: [
		{
			service: "Linkedin",
			username: person?.linkedin,
		},
		{
			service: "Instagram",
			username: person?.insta,
		},
		{
			service: "Phone",
			username: person?.tel,
		},
		{
			service: "Mail",
			username: person?.email,
		},
		{
			service: "Twitter",
			username: person?.twitter,
		},
	],
	color: colors[Math.floor(Math.random() * colors.length)],
});

export const colors = [
	"red",
	"pink",
	"purple",
	"dark-purple",
	"indigo",
	"blue",
	"light-blue",
	"cyan",
	"green",
	"light-green",
	"orange",
	"brown",
];

export const tabs = [
	{
		title: "All",
		icon: "group",
		color: "indigo",
		id: "",
	},
	{
		title: "Core Members",
		icon: "diversity_3",
		color: "green",
		id: "core",
	},
	{
		title: "Design",
		icon: "draw",
		color: "orange",
		id: "design",
	},
	{
		title: "Content",
		icon: "history_edu",
		color: "purple",
		id: "content",
	},
	{
		title: "Technical",
		icon: "code",
		color: "blue",
		id: "tech",
	},
	{
		title: "Social Media / PR",
		icon: "handshake",
		color: "pink",
		id: "social",
	},
	{
		title: "Volunteers",
		icon: "hub",
		color: "yellow",
		id: "volunteers",
	},
];

export const getFieldByOther = (field, value, arr, request) =>
	arr.find((a) => a[field] === value)?.request;

export const allowHeaderRoutes = [
	"/about",
	"/blogs",
	"/events",
	"/gallery",
	"/team",
	"/notable-alumni",
	"/admin/members",
	"/admin/write",
];
export const allowFooterRoutes = [
	"/",
	"/about",
	"/blogs",
	"/events",
	"/gallery",
	"/team",
	"/notable-alumni",
	"/admin",
	"/admin/members",
	"/admin/applications",
	"/admin/write",
];

export const allowHeader = (route) => {
	if (allowHeaderRoutes.includes(route)) return true;
	if (route === "/forms/add-member-details") return false;
	if (route.slice(0, 6) === "/blog/") return true;
	if (route.slice(0, 7) === "/forms/") return true;
	if (route.slice(0, 6) === "/edit/") return true;
};
export const allowFooter = (route) => {
	if (allowFooterRoutes.includes(route)) return true;
	if (route.slice(0, 8) === "/recipe/") return true;
	if (route.slice(0, 6) === "/blog/") return true;
	if (route.slice(0, 7) === "/forms/") return true;
	if (route.slice(0, 6) === "/edit/") return true;
};

export const rollNoRange = [
	{
		start: 19101,
		end: 19157,
	},
	{
		start: 19201,
		end: 19246,
	},
	{
		start: 19301,
		end: 19332,
	},
	{
		start: 20101,
		end: 20165,
	},
	{
		start: 20201,
		end: 20250,
	},
	{
		start: 20301,
		end: 20337,
	},
	{
		start: 21101,
		end: 21157,
	},
	{
		start: 21201,
		end: 21253,
	},
	{
		start: 21301,
		end: 21335,
	},
];

export const validRoll = (roll) => {
	for (const range of rollNoRange) {
		if (+roll >= range.start && +roll <= range.end) return true;
	}
	return false;
};
